var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ellipsis-cell-outer d-none d-sm-flex"},[_c('div',{staticClass:"ellipsis-cell-inner"},[_vm._t("default")],2)]),_c('div',{staticClass:"d-flex d-sm-none"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }